import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // Verificar si la respuesta es HTML (error de ngrok)
    if (typeof response.data === 'string' && response.data.includes('<!DOCTYPE html>')) {
      return Promise.reject(new Error('Error de conexión con el servidor. Por favor, verifica la configuración de ngrok.'));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    // Manejar errores de respuesta
    if (error.response?.data) {
      const errorMessage = typeof error.response.data === 'string' 
        ? error.response.data 
        : error.response.data.message || 'Error en la solicitud';
      return Promise.reject(new Error(errorMessage));
    }
    
    // Si es un error de ngrok, mostrar un mensaje más amigable
    if (error.response?.data?.includes('<!DOCTYPE html>')) {
      return Promise.reject(new Error('Error de conexión con el servidor. Por favor, verifica la configuración de ngrok.'));
    }
    
    return Promise.reject(error);
  }
);

export default instance; 